import { ProviderError } from './ProviderError';
import {
	BaseEventType,
	ProviderEventType,
} from '../types/enums/ProviderEventType';

export class ProviderEvent<D = any> {
	readonly tstamp: string;
	constructor(
		readonly type: ProviderEventType,
		readonly data?: D,
	) {
		this.tstamp = new Date().toISOString();
	}
	get value() {
		if (this.data instanceof Event) {
			if (this.data instanceof MessageEvent) {
				const { data } = this.data;
				if (typeof data !== 'string') return data;
				try {
					const result = JSON.parse(data);
					const type = Object.prototype.toString.call(result);
					return type === '[object Object]' || type === '[object Array]'
						? result
						: data;
				} catch (err) {
					return data;
				}
			}
		}
		return this.data;
	}
}

export class ProviderErrorEvent<D = any> extends ProviderEvent<D> {
	constructor(
		data: D,
		readonly error?: ProviderError,
	) {
		super(BaseEventType.ERROR, data);
	}
}

export class ProviderOpenEvent<D = any> extends ProviderEvent<D> {
	constructor(data: D) {
		super(BaseEventType.OPEN, data);
	}
}

export class ProviderCloseEvent<D = any> extends ProviderEvent<D> {
	constructor(
		data: D,
		readonly reason: string,
	) {
		super(BaseEventType.CLOSE, data);
	}
}

export class ProviderMessageEvent<D = any> extends ProviderEvent<D> {
	constructor(data: D) {
		super(BaseEventType.MESSAGE, data);
	}
}
